<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listGenders"
        :title-table="$t('Gender')"
        module="genderSettingsModule"
        sort-name="nome"
        add-permission="ROLE_SEXO_INSERIR"
        view-permission="ROLE_SEXO_CONSULTAR"
        edit-permission="ROLE_SEXO_ATUALIZAR"
        delete-permission="ROLE_SEXO_DELETAR"
        @add="addNew"
        @edit="edit"
      />
      <FormGender
        v-else
        @cancelar="cancelar"
      />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import FormGender from './forms/FormGender.vue'

export default {
  components: {
    BRow,
    BCol,
    TableComponents,
    FormGender,
  },
  computed: {
    ...mapState('genderSettingsModule', {
      listGenders: state => state.listGenders,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: 'Id',
          field: 'id',
        },
        {
          label: 'Nome',
          field: 'nome',
        },
        {
          label: 'Sigla',
          field: 'sigla',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
    }
  },
  methods: {
    addNew() {
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch('genderSettingsModule/prepareToEditGender', data)
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    },
  },
}
</script>
